export default __webpack_public_path__ + "static/media/hcelos.becbae19.png";